import http from '@/axios/http'

const fetch = ({ url = '/get_categories' }) =>
  http
    .get(url)
    .then(response => response.data)

export default fetch
